import { IAccount } from "src/models";
import { YupOptionalSchema } from "src/utility/types/yupHelperTypes";
import * as Yup from "yup";

export const accountDetailsValidationSchema = Yup.object<
  YupOptionalSchema<IAccount>
>({
  organization: Yup.string()
    .min(
      1,
      "Organization name must be 2-50 ASCII letters, numbers, hyphens, and underscores; and must begin and end with a letter/number.",
    )
    .max(
      100,
      "Organization name must be 2-50 ASCII letters, numbers, hyphens, and underscores; and must begin and end with a letter/number.",
    )
    .matches(
      /^[a-zA-Z0-9][ a-zA-Z0-9_-]{0,48}[a-zA-Z0-9]$/,
      "Organization name must be 2-50 ASCII letters, numbers, hyphens, underscores, and spaces; and must begin and end with a letter/number.",
    )
    .required("This is a required field"),
});
